import { memo } from 'react';

import { formatCreditCount } from '~/utils/creditUtils';

export type CreditUsageBreakdownGiftCreditsRowProps = {
  giftCreditsBalance: number;
};

export const CreditUsageBreakdownGiftCreditsRow = memo(
  ({ giftCreditsBalance }: CreditUsageBreakdownGiftCreditsRowProps) => {
    if (giftCreditsBalance <= 0) {
      return null;
    }

    return (
      <div
        data-testid="CREDIT_USAGE_BREAKDOWN_GIFT_CREDITS"
        className="flex items-center justify-between gap-1 text-12"
      >
        <div className="flex items-center gap-1">
          <span className="size-1.5 rounded-full ads:bg-ads-altitude-9 bg-blue-9" />
          <span className="truncate ads:text-metadata text-gray-9">One-time gift</span>
        </div>
        <span className="truncate">{formatCreditCount(giftCreditsBalance)} remaining</span>
      </div>
    );
  },
);

CreditUsageBreakdownGiftCreditsRow.displayName = 'CreditUsageBreakdownGiftCreditsRow';
